import React from 'react';
import Hero from './Hero';
import Nav from './Nav';

const HomeSection = () => (
  <>
    <Nav />
    <Hero />
  </>
);

export default HomeSection;
